import { Dex360Audit } from '@/api/dex360-audit';
import { format } from 'date-fns';
import { Eye } from 'lucide-react';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
} from '@/components/ui/sheet';

export const Dex360AuditDetails = ({ audit }: { audit: Dex360Audit }) => {
    const [open, setOpen] = useState(false);

    return (
        <div>
            <Button
                variant="ghost"
                size="icon"
                className="h-8 w-8"
                onClick={() => setOpen(true)}
            >
                <Eye className="h-4 w-4" />
                <span className="sr-only">View details</span>
            </Button>

            <Sheet open={open} onOpenChange={setOpen}>
                <SheetContent>
                    <SheetHeader>
                        <SheetTitle>Audit Details</SheetTitle>
                    </SheetHeader>
                    <div className="space-y-6 mt-6">
                        <div className="grid gap-4">
                            {audit.error && (
                                <div>
                                    <label className="text-sm font-medium">Error</label>
                                    <div className="text-sm text-muted-foreground">{audit.error}</div>
                                </div>
                            )}

                            {audit.status && (
                                <div>
                                    <label className="text-sm font-medium">Error Status</label>
                                    <div className="text-sm text-muted-foreground">{audit.status}</div>
                                </div>
                            )}

                            {audit.errorDate && (
                                <div>
                                    <label className="text-sm font-medium">Error Date</label>
                                    <div className="text-sm text-muted-foreground">
                                        {format(new Date(audit.errorDate), 'PPP')}
                                    </div>
                                </div>
                            )}

                            <div>
                                <label className="text-sm font-medium">
                                    Locations ({audit.locations?.length})
                                </label>
                                <div className="text-sm text-muted-foreground">
                                    {audit.locations?.join(', ') || 'No locations'}
                                </div>
                            </div>
                        </div>
                    </div>
                </SheetContent>
            </Sheet>
        </div>
    );
};